window.HRFurnitureShipping = {
  version: "1.0",

  handles: {
    "Toronto": "delivery-free",
    "Brampton": "delivery-free",
    "Mississauga": "delivery-free",
    "Vaughan": "delivery-free",
    "Markham": "delivery-free",
    "North York": "delivery-free",
    "Scarborough": "delivery-free",
    "Etobicoke": "delivery-free",
    "Malton": "delivery-free",
    "East York": "delivery-free",
    "Woodbridge": "delivery-free",
    "Montreal": "delivery-free",
    "Ottawa": "delivery-free",

    "Milton": "milton-oakville-richmond-delivery",
    "Richmond Hill": "milton-oakville-richmond-delivery",
    "Oakville": "milton-oakville-richmond-delivery",

    "Burlington": "burlington-delivery",
    "Hamilton": "hamilton-delivery",
    "Pickering": "pickering-delivery",
    "Ajax": "ajax-delivery",
    "Oshawa": "oshawa-delivery",

    "Whitby": "whitby-guelph-delivery",
    "Guelph": "whitby-guelph-delivery",

    "Cambridge": "cambridge-delivery",

    "Bowmanville": "bowmanville-waterloo-delivery",
    "Kitchener": "bowmanville-waterloo-delivery",
    "Waterloo": "bowmanville-waterloo-delivery",

    "St. Catharines": "st-catharines-delivery",

    "Niagara Falls": "niagara-falls-london-delivery",
    "London": "niagara-falls-london-delivery"
  }
};

document.addEventListener("change", function (e) {

  if (e.target.id !== "hr-delivery-city") return;

  const city = e.target.value;

  localStorage.setItem("hr_delivery_city", city);

  const hidden = document.getElementById("hr-delivery-handle");

  if (hidden) {
    hidden.value = window.HRFurnitureShipping.handles[city] || "";
  }

  // Update delivery immediately
  if (window.HRDeliverySync) {
    setTimeout(() => {
      window.HRDeliverySync.sync();
    }, 100);
  }

});

window.HRFurnitureShipping.variantIds = {
  "delivery-free": 47612699639957,
  "milton-oakville-richmond-delivery": 47612712616085,
  "burlington-delivery": 47612715303061,
  "hamilton-delivery": 47612718776469,
  "pickering-delivery": 47612721791125,
  "ajax-delivery": 47612722512021,
  "oshawa-delivery": 47612723134613,
  "whitby-guelph-delivery": 47612729294997,
  "cambridge-delivery": 47612816785557,
  "bowmanville-waterloo-delivery": 47612820619413,
  "st-catharines-delivery": 47612820848789,
  "niagara-falls-london-delivery": 47612844572821
};
document.addEventListener("DOMContentLoaded", function () {

  const select = document.getElementById("hr-delivery-city");
  if (!select) return;

  const savedCity = localStorage.getItem("hr_delivery_city");
  if (!savedCity) return;

  select.value = savedCity;

  select.dispatchEvent(new Event("change", { bubbles: true }));

});